<ng-template #FormDeadModal>

<form class="form-validation" *ngIf="lang">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closepop()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="overflow: auto;">
      
      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover" id="table1">
        
        <thead>
          <tr>
            <th>No.</th>
            <th>{{ lang.code }}</th>
            <th>{{ lang.title }}</th>
            <th>{{ lang.documentType }}</th>
            <th>{{ lang.origin }}</th>
            <th>{{ lang.actualRevision }}</th>
            <th>{{ lang.currentRevision }}</th>
            <th>{{ lang.writtenBy }}</th>
            <th>{{ lang.expiryDate }}</th>
            <th>{{ lang.daysleft }}</th>
            <th>{{ lang.status }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let record of problem let i = index" id="{{record.doc_id}}">
            <td>{{i+1}}</td>
            <td>{{record.doc_code}}</td>
            <td>{{record.doc_title}}</td>
            <td>{{record.doc_type }}</td>
            <td>{{record.doc_origin }}</td>
            <td>{{record.revision }}</td>
            <td>{{record.revision_date }}</td>
            <td>{{record.written_by }}</td>
            <td>{{record.expiry_date }}</td>
            <td><div [innerHTML]="record.days_left_color"></div></td>
            <td><div [innerHTML]="record.doc_status_class"></div></td>


          </tr>
        </tbody>

      </table>
    </div>
  </div>

</form>
</ng-template>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
    <ngx-doc-viewer url="https://angular-doc-viewer.firebaseapp.com/assets/file-sample_150kB.pdf" viewer="google" style="width:100%;height:50vh;"></ngx-doc-viewer>
  </div>
</ng-template>